import {
  GetLocationsDocument,
  UpdateLocationDocument,
  UpdateLocationMutation,
  UpdateLocationMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateLocation = () => {
  const [executeMutation] = useMutation(UpdateLocationDocument, {
    extractorFn: (data: UpdateLocationMutation) => data.locationsMutations.updateLocationsLocation,
  })

  const updateLocation = async (variables: UpdateLocationMutationVariables) => {
    return executeMutation({
      variables,
      refetchQueries: [
        {
          query: GetLocationsDocument,
        },
      ],
    })
  }

  return {
    updateLocation,
  }
}
